<template>
	<div class="nav-bar">
		<ul class="nav-list">
			<li>Routes:</li>
			<li v-for="route in routes" :key="route.path">
				<router-link
					:class="{
						'custom-active': route.name === this.$route.name,
					}"
					:to="route.path"
					>{{ route.name }}</router-link
				>
			</li>
		</ul>
		<div class="options-menu" v-if="dev">
			<div class="options-container">
				<button
					class="show-hide"
					:class="{ active: showUserPreferences }"
					@click="showUserPreferences = !showUserPreferences"
				>
					user preferences
				</button>
				<div v-if="showUserPreferences" class="options">
					<button
						v-for="(value, key) in userPreferences"
						:key="key"
						class="option"
						:class="{ active: value }"
						@click="userToggleOption(key)"
					>
						{{ key }}
					</button>
				</div>
			</div>
			<div v-if="isDev" class="options-container">
				<button
					class="show-hide"
					:class="{ active: showDevPreferences }"
					@click="showDevPreferences = !showDevPreferences"
				>
					dev preferences
				</button>
				<div v-if="showDevPreferences" class="options">
					<button
						v-for="(value, key) in devPreferences"
						:key="key"
						class="option"
						:class="{ active: value }"
						@click="devToggleOption(key)"
					>
						{{ key }}
					</button>
				</div>
			</div>
			<template v-if="game.joined && isDev">
				<div class="options-container">
					<button
						class="show-hide"
						:class="{ active: showGameState }"
						@click="showGameState = !showGameState"
					>
						Game state
					</button>
					<div v-if="showGameState" class="options">
						<button
							v-for="(value, key) in devPlayMock"
							:key="key"
							class="option"
							@click="handleDevMockPlay(value)"
						>
							{{ key }}
						</button>
						<button class="option" @click="tryPassTurn">
							passTurn to server
						</button>
						<button class="option" @click="tryRefreshState">
							refreshState
						</button>
					</div>
				</div>
				<div class="options-container">
					<button
						class="show-hide"
						:class="{ active: showRemoveCards }"
						@click="showRemoveCards = !showRemoveCards"
					>
						Dev remove card
					</button>
					<div v-if="showRemoveCards" class="options">
						<button
							v-for="(value, index) in game.settings.values"
							:key="index"
							class="value option"
							@click="handleRemoveCard(value)"
						>
							Remove {{ value }}
						</button>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
	data() {
		return {
			dev: true,
			showUserPreferences: false,
			showDevPreferences: false,
			showGameState: true,
			showRemoveCards: true,
		};
	},
	computed: {
		...mapGetters([
			"userPreferences",
			"devPreferences",
			"isDev",
			"devPlayMock",
			"game",
			"mockingServer",
		]),
		routes() {
			const arr = [];
			const routes = this.$router.getRoutes();
			routes.forEach(route => {
				arr.push({ path: route.path, name: route.name });
			});
			return arr;
		},
	},
	methods: {
		...mapActions([
			"userToggleOption",
			"devToggleOption",
			"devController",
			"devStartGame",
			"tryCheckGuess",
			"tryPassTurn",
			"tryRefreshState",
		]),
		handleDevMockPlay(control) {
			if (control === "DEV_DEAL_CARDS") {
				this.devStartGame();
			} else {
				this.devController(control);
			}
		},
		handleRemoveCard(aValue) {
			this.tryCheckGuess({ value: aValue });
		},
	},
};
</script>

<style lang="scss">
@import "../../assets/scss/main.scss";

.nav-bar {
	width: 100vw;
	max-height: 80px;
	overflow: visible;

	padding: 2em 4em;
	display: flex;
	justify-content: space-between;
}

.nav-list {
	list-style: none;

	li {
		display: inline-block;
		margin-right: 12px;

		color: darken($blue-lightest, 20%);
		font-size: 14px;
		text-transform: uppercase;

		a {
			color: $blue-lightest;
			font-weight: bold;
			transition: 0.2s;
			&:hover {
				color: lighten($blue-lightest, 20%);
			}
		}

		a.router-link-active,
		a.router-link-active,
		a.custom-active {
			color: $white;
		}
	}
}

$active: rgb(29, 150, 83);
$option-grey: rgb(105, 110, 122);

.options-menu {
	display: flex;

	.options-container {
		z-index: 9;
		text-align: right;
		button {
			color: white;
			margin: 0 4px;
			padding: 4px 8px;
			cursor: pointer;
			transition: 0.2s;
			&:hover {
				background-color: lighten($option-grey, 5%);
			}
			background-color: $option-grey;
		}
		.show-hide {
			box-shadow: 0px 2px rgba(0, 0, 0, 0.2);
			&.active {
				box-shadow: 0px -2px rgba(0, 0, 0, 0.2);
				transform: translateY(1px);
				background-color: darken($option-grey, 10%);
			}
			border-radius: 3px;
		}

		.options {
			margin-top: 8px;
			display: block;
			text-align: right;
			.option {
				display: block;
				box-shadow: 0px 2px rgba(0, 0, 0, 0.2);
				color: white;
				margin: 0 4px;
				padding: 4px 8px;
				&.active {
					background-color: $active;
					&:hover {
						background-color: lighten($active, 5%);
					}
				}
				&:active {
					box-shadow: 0px -2px rgba(0, 0, 0, 0.2);
					transform: translateY(1px);
					background-color: darken($option-grey, 10%);
				}
				&.hover-green:hover {
					background-color: $active;
				}
				&:first-child {
					border-radius: 3px 3px 0px 0px;
				}
				&:last-child {
					border-radius: 0px 0px 3px 3px;
				}
			}
		}
	}
}
</style>
